import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-68830429"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "maincontainer w-full pt-3 pl-5 pr-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Dashboard", -1))
const _hoisted_3 = { class: "mt-5" }
const _hoisted_4 = { class: "lg:flex justify-between mt-5" }
const _hoisted_5 = { class: "sm:mb-2 lg:mb-0 mr-3 flex justify-center items-center cursor-pointer h-17 rounded w-full border border-black" }
const _hoisted_6 = { class: "py-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-normal px-2 text-black" }, "Active Users", -1))
const _hoisted_8 = { class: "text-center mt-1 font-bold text-lg text-black" }
const _hoisted_9 = { class: "mr-3 sm:mb-2 lg:mb-0 flex relative justify-center items-center indicateBoxes h-17 rounded w-full borderlightgreen bg-opacity-green" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-full absolute rounded" }, null, -1))
const _hoisted_11 = { class: "flex rounded items-center regular text-sm" }
const _hoisted_12 = { class: "py-1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-normal text-center" }, "Completed", -1))
const _hoisted_14 = { class: "mt-1 text-center font-bold text-lg" }
const _hoisted_15 = { class: "mr-3 sm:mb-2 lg:mb-0 flex relative justify-center items-center indicateBoxes h-17 rounded w-full borderProgress bg-opacity-progress" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-full absolute rounded" }, null, -1))
const _hoisted_17 = { class: "flex rounded items-center regular text-sm" }
const _hoisted_18 = { class: "py-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-normal text-center" }, "In Progress", -1))
const _hoisted_20 = { class: "mt-1 text-center font-bold text-lg" }
const _hoisted_21 = { class: "mr-3 sm:mb-2 lg:mb-0 flex relative justify-center items-center indicateBoxes h-17 rounded w-full borderGrey bg-opacity-notstarted" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-full absolute rounded" }, null, -1))
const _hoisted_23 = { class: "flex rounded items-center regular text-sm" }
const _hoisted_24 = { class: "py-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-normal text-center" }, "Not Started", -1))
const _hoisted_26 = { class: "mt-1 text-center font-bold text-lg" }
const _hoisted_27 = { class: "mr-3 sm:mb-2 lg:mb-0 flex relative justify-center items-center indicateBoxes h-17 rounded w-full borderOverdue bg-opacity-overdue" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-full absolute rounded" }, null, -1))
const _hoisted_29 = { class: "flex rounded items-center regular text-sm" }
const _hoisted_30 = { class: "py-1" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-normal text-center" }, "Overdue", -1))
const _hoisted_32 = { class: "mt-1 text-center font-bold text-lg" }
const _hoisted_33 = { class: "mr-3 sm:mb-2 lg:mb-0 flex relative justify-center items-center indicateBoxes h-17 rounded w-full borderPrimary bg-opacity-activecourses" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-full absolute rounded" }, null, -1))
const _hoisted_35 = { class: "flex rounded items-center regular text-sm" }
const _hoisted_36 = { class: "py-1" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-normal text-center" }, "Active Courses", -1))
const _hoisted_38 = { class: "mt-1 text-center font-bold text-lg" }
const _hoisted_39 = { class: "bg-white mt-8 p-5 gap-4 rounded-sm border border-lightgrey" }
const _hoisted_40 = { class: "flex justify-between" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-base font-semibold" }, "Status of All Courses")
], -1))
const _hoisted_42 = { class: "export-section flex flex-row-reverse cursor-pointer" }
const _hoisted_43 = { class: "w-full mt-3" }
const _hoisted_44 = { class: "card flex justify-center min-h-170 p-2" }
const _hoisted_45 = {
  key: 0,
  id: "chart"
}
const _hoisted_46 = {
  key: 1,
  class: "mt-8 text-sm text-center text-black"
}
const _hoisted_47 = { class: "lastDivOfDashboard1 justify-between bg-white items-center mt-8 p-5 gap-4 rounded-sm border border-lightgrey" }
const _hoisted_48 = { class: "lastDivOfDashboard" }
const _hoisted_49 = { class: "card min-h-170 chart p-4 flex" }
const _hoisted_50 = { class: "flex justify-between" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-base font-semibold" }, "Status of Course", -1))
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "flex mt-3" }
const _hoisted_54 = { class: "w-full" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  hidden: "",
  value: ""
}, "Select a Course", -1))
const _hoisted_56 = ["value"]
const _hoisted_57 = {
  key: 0,
  class: "p-2 flex justify-center"
}
const _hoisted_58 = { id: "chart-container" }
const _hoisted_59 = {
  key: 1,
  class: "w-full h-full flex justify-center items-center"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-primary text-sm font-semibold" }, "No Courses Found", -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { class: "lastDivOfDashboard card chart min-h-170 bg-white rounded p-4" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-base font-semibold" }, "Feedback", -1))
const _hoisted_64 = {
  key: 0,
  class: "card mt-3 p-3 flex overflow-auto"
}
const _hoisted_65 = { class: "flex items-center justify-between p-3" }
const _hoisted_66 = { class: "text-sm font-semibold w-3/6" }
const _hoisted_67 = { class: "w-3/6 flex justify-end mr-1" }
const _hoisted_68 = { style: {"display":"none"} }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("symbol", { id: "fivestars" }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Star New",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M120 0H0V24H120V0ZM14.125 9.98047L12 3.44141L9.875 9.98047H3L8.5625 14.0195L6.4375 20.5586L12 16.5176L17.5625 20.5605L15.4375 14.0195L21 9.98047H14.125ZM38.125 9.98047L36 3.44141L33.875 9.98047H27L32.5625 14.0195L30.4375 20.5586L36 16.5176L41.5625 20.5605L39.4375 14.0195L45 9.98047H38.125ZM60 3.44141L62.125 9.98047H69L63.4375 14.0195L65.5625 20.5605L60 16.5176L54.4375 20.5586L56.5625 14.0195L51 9.98047H57.875L60 3.44141ZM86.125 9.98047L84 3.44141L81.875 9.98047H75L80.5625 14.0195L78.4375 20.5586L84 16.5176L89.5625 20.5605L87.4375 14.0195L93 9.98047H86.125ZM108 3.44141L110.125 9.98047H117L111.438 14.0195L113.562 20.5605L108 16.5176L102.438 20.5586L104.562 14.0195L99 9.98047H105.875L108 3.44141Z",
      fill: "white"
    })
  ])
], -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = { class: "rating" }
const _hoisted_72 = ["value"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", null, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#fivestars" })
], -1))
const _hoisted_74 = {
  key: 0,
  class: "border border-lightgrey"
}
const _hoisted_75 = {
  key: 1,
  class: "w-full h-full flex justify-center items-center"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-primary text-sm font-semibold" }, "No FeedBacks Yet", -1))
const _hoisted_77 = [
  _hoisted_76
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.dashboardData.users), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.dashboardData?.status?.completed || 0), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.dashboardData?.status?.inprogress || 0), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.dashboardData?.status?.notstarted || 0), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.dashboardData?.status?.overdue || 0), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.dashboardData?.totalCourses || 0), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("button", {
              class: "btnprimary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.generateAllCoursesCsv()))
            }, "Export")
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            (_ctx.dashboardData.status)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createVNode(_component_apexchart, {
                    ref: "chart",
                    type: "bar",
                    height: "470",
                    options: _ctx.chartOptionsForStackedChart,
                    series: _ctx.stackBarChart
                  }, null, 8, ["options", "series"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_46, " No courses assigned to users"))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              (_ctx.selectedCourse)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btnprimary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.generateCsv()))
                  }, "Export"))
                : _createCommentVNode("", true)
            ]),
            (_ctx.allCourses.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCourse) = $event)),
                        class: "inputboxstyling",
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.generateGraph()))
                      }, [
                        _hoisted_55,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCourses, (course) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: course.masterCourseId,
                            key: course.masterCourseId,
                            class: _normalizeClass(course.courseName.length < 15 ? '' : _ctx.text - _ctx.sm)
                          }, _toDisplayString(course.courseName), 11, _hoisted_56))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.selectedCourse]
                      ])
                    ])
                  ]),
                  (_ctx.showGraph)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createVNode(_component_apexchart, {
                            type: "donut",
                            options: _ctx.chartOptions,
                            series: _ctx.series
                          }, null, 8, ["options", "series"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_59, _hoisted_61))
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _hoisted_63,
          (_ctx.courseFeedBackInfo.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseFeedBackInfo, (object, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: object }, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.getCourseName(object._id)), 1),
                      _createElementVNode("div", _hoisted_67, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_68, _hoisted_70)),
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("progress", {
                            class: "rating-bg",
                            value: _ctx.averageRating(object),
                            max: 5
                          }, null, 8, _hoisted_72),
                          _hoisted_73
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["text-primary text-sm font-semibold pl-4 mt-1", _ctx.averageRating(object) == 0 ? 'pl-7' : 'pl-4'])
                      }, _toDisplayString(_ctx.averageRating(object)), 3)
                    ]),
                    (index != _ctx.courseFeedBackInfo.length - 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_75, _hoisted_77))
        ])
      ])
    ])
  ]))
}